import { MPAC_CONFIGURATION_KEYS } from '@atlassian/mpac-types';
import React from 'react';

import FeaturedSectionContainer from '../SlidesConfigContainer/FeaturedSectionContainer';
import HomePageBannerContainer from '../SlidesConfigContainer/HomePageBannerContainer/HomePageBannerContainer';

const GetConfiguratorComponentById = ({ id, getSectionConfiguration }) => {
  switch (id) {
    case MPAC_CONFIGURATION_KEYS.homePageBanner: {
      const sectionConfig = getSectionConfiguration(id) ?? undefined;

      return <HomePageBannerContainer key={id} defaultValue={sectionConfig} name={id} />;
    }
    case MPAC_CONFIGURATION_KEYS.featuredSection: {
      const featuredSectionConfig = getSectionConfiguration(id);
      return <FeaturedSectionContainer key={id} defaultValue={featuredSectionConfig} name={id} />;
    }
    default:
      return null;
  }
};

const MemoizedGetConfiguratorComponentById = React.memo(GetConfiguratorComponentById);

export default MemoizedGetConfiguratorComponentById;
